module.exports = __webpack_public_path__ + "img/tag3.8551490a.png";